import React from 'react';
import cn from 'classnames';

import { useTranslation } from '@lt/localization';
import { formatDateToDayShort } from '../../../../../../../utils/dateUtils';
import { getFlightTypeData, getHoursSafe } from '../../../utils/flightUtils';
import FlightDaysDiff from '../FlightDaysDiff';
import FlightType from '../FlightType';
import { UNKNOWN_LUGGAGE } from '../constants';

import FlightsLuggage from '../Luggage/FlightsLuggage/FlightsLuggage';
import type { FlightsData } from '../../../types/flights';

import styles from './flightsRouteSidebar.module.css';

interface Props {
  isMobile: boolean;
  isFlightsTypeEqual: boolean;
  isDateChangable: boolean;
  data: FlightsData['to'];
}

// TODO: вместо data сделать нормальные пропсы как в FlightsRouteBack
const FlightsRouteSidebar = ({
  data,
  isMobile,
  isFlightsTypeEqual,
  isDateChangable,
}: Props) => {
  const { t } = useTranslation();
  const { arrival, departure, time, luggage: luggageFromData } = data;
  const luggage = isDateChangable ? UNKNOWN_LUGGAGE : luggageFromData;

  const timeRange =
    time && departure && arrival
      ? `${getHoursSafe(departure)}-${getHoursSafe(arrival)}`
      : t('monthSegments.noData');

  const isShowingFlightType = isMobile && !isFlightsTypeEqual;

  return (
    <>
      {isShowingFlightType && (
        <FlightType
          showFlightClass={!isDateChangable}
          showIcon={false}
          showDescription={false}
          showTooltip={!isMobile}
          type={getFlightTypeData(data)}
        />
      )}

      <div className={cn(styles.text, styles.timeText)}>
        {!isDateChangable && <span>{timeRange}</span>}
        {departure && arrival ? (
          <FlightDaysDiff previousDate={departure} nextDate={arrival} />
        ) : (
          t('monthSegments.noData')
        )}
      </div>

      <div className={styles.dateAndLuggage}>
        {departure && (
          <span className={styles.text}>{formatDateToDayShort(departure)}</span>
        )}
        <FlightsLuggage isLabelInside luggage={luggage} isMobile={isMobile} />
      </div>
    </>
  );
};

export default FlightsRouteSidebar;
